import { Account } from './account'

export type Group = {
  id: number
  parent_id: number | null
  name: string
  accounts: Account[]
}

export enum PrivacySetting {
  ALL_PUBLIC = 'all_public',
  GROUP_PUBLIC = 'group_public', // also known as alias for "in their group"
}
